import * as tslib_1 from "tslib";
import { ElementRef, EventEmitter, OnInit, QueryList } from '@angular/core';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { State } from '../../shared/state-view/state.model';
import { SatPopover } from '@ncstate/sat-popover';
import { SearchQuery } from '../models/search-query.model';
import { UserService } from '../../shared/user/user.service';
var EventResultsListingComponent = /** @class */ (function () {
    function EventResultsListingComponent(_userService) {
        this._userService = _userService;
        this.state = State.Empty;
        this.eventPageIndex = 0;
        this.eventPageSize = 25;
        this.totalAviationEvents = 0;
        this.eventMouseEnter = new EventEmitter();
        this.eventMouseLeave = new EventEmitter();
        this.filtersChanged = new EventEmitter();
        this.filtersDateChanged = new EventEmitter();
        this.showAirportsToggleChanged = new EventEmitter();
        this.eventPageChanged = new EventEmitter();
        this.showAirports = false;
    }
    EventResultsListingComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this._userInfo = this._userService.userInfo.getValue();
                this._userService.userInfo.subscribe(function (u) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return tslib_1.__generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                // Update userInfo
                                this._userInfo = u;
                                // Set state to loaded
                                _a = this;
                                return [4 /*yield*/, this._userService.getShowAirportsFlag()];
                            case 1:
                                // Set state to loaded
                                _a.showAirports = _b.sent();
                                this.state = State.Content;
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    EventResultsListingComponent.prototype.onEventHover = function (aviationEvent, hover) {
        if (hover) {
            this.eventMouseEnter.emit(aviationEvent);
        }
        else {
            this.eventMouseLeave.emit(aviationEvent);
        }
    };
    EventResultsListingComponent.prototype.onFiltersChanged = function () {
        this.filtersChanged.emit(this.query);
    };
    EventResultsListingComponent.prototype.onFiltersChangedDate = function () {
        this.filtersDateChanged.emit(this.query);
    };
    /**
     * Returns a jQuery element container for the given airport.
     */
    EventResultsListingComponent.prototype.getEventEl = function (aviationEvent) {
        var i = this.aviationEvents.indexOf(aviationEvent);
        if (i < 0) {
            return null;
        }
        var el = this.aviationEventEls.toArray()[i];
        // @ts-ignore
        return $(el.nativeElement);
    };
    /**
     * Scrolls the airports list to the specified airport, marking it as selected.
     */
    EventResultsListingComponent.prototype.scrollToEvent = function (aviationEvent) {
        if (!this.aviationEventListEl) {
            return;
        }
        // @ts-ignore
        var $containerEl = $(this.aviationEventListEl.nativeElement);
        var $el = this.getEventEl(aviationEvent);
        if (!$el) {
            return;
        }
        var position = $el[0].offsetTop;
        $containerEl.stop(true);
        $containerEl.animate({ scrollTop: position }, 500);
    };
    EventResultsListingComponent.prototype.onShowAirportsToggleChanged = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._userService.saveShowAirportsFlag(this.showAirports)];
                    case 1:
                        _a.sent();
                        this.showAirportsToggleChanged.emit();
                        return [2 /*return*/];
                }
            });
        });
    };
    EventResultsListingComponent.prototype.onEventPageChanged = function (e) {
        this.eventPageChanged.emit(e);
        if (!this.aviationEventListEl) {
            return;
        }
        // @ts-ignore
        var $containerEl = $(this.aviationEventListEl.nativeElement);
        $containerEl.stop(true);
        $containerEl.animate({ scrollTop: 0 }, 500);
    };
    return EventResultsListingComponent;
}());
export { EventResultsListingComponent };
